import styled from "styled-components";

export const Container = styled.div`
   border: 2px solid #f5f5f5;
  border-radius: 50%;
  border-top: 2px solid transparent;
  width: 28px;
  height: 28px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
